import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Redirect www to non-www to prevent duplicate content
if (window.location.hostname === 'www.gewerbeflaeche-mieten.de') {
  window.location.replace(
    window.location.href.replace('www.gewerbeflaeche-mieten.de', 'gewerbeflaeche-mieten.de')
  );
} else {
  const container = document.getElementById("root")!;
  if (container.dataset.prerendered === "true") {
    hydrateRoot(container, <App />);
  } else {
    createRoot(container).render(<App />);
  }
}
